const VENTAS_FACTURA = 'VENFAC'
const VENTAS_BOLETA = 'VENBOL'
const VENTAS_NOTACREDITO_FACTURA = 'VENNOTCREFACT'
const VENTAS_NOTACREDITO_BOLETA = 'VENNOTCREBOLE'
const VENTAS_NOTADEBITO = 'VENNOTDEB'
const VENTAS_TICKET = 'VENTIC'
const GUIAELECTRONICA_TRANSFERENCIAS = 'GUIAELECTTRANS'
const GUIAREMISION_REMITENTE = 'GUIAREMISONREMITENT'

const __dictionary = {
  [VENTAS_FACTURA]: {
    id: VENTAS_FACTURA,
    nombre: 'VENTAS FACTURA'
  },
  [VENTAS_BOLETA]: {
    id: VENTAS_BOLETA,
    nombre: 'VENTAS BOLETA'
  },
  [VENTAS_NOTACREDITO_FACTURA]: {
    id: VENTAS_NOTACREDITO_FACTURA,
    nombre: 'VENTAS NOT CRED FACT'
  },
  [VENTAS_NOTACREDITO_BOLETA]: {
    id: VENTAS_NOTACREDITO_BOLETA,
    nombre: 'VENTAS NOT CRED BOLE'
  },
  [VENTAS_NOTADEBITO]: {
    id: VENTAS_NOTADEBITO,
    nombre: 'VENTAS NOTA DEBITO'
  },
  [VENTAS_TICKET]: {
    id: VENTAS_TICKET,
    nombre: 'VENTAS TICKET'
  },
  [GUIAELECTRONICA_TRANSFERENCIAS]: {
    id: GUIAELECTRONICA_TRANSFERENCIAS,
    nombre: 'GUIA ELECTRONICA - VENTAS'
  },
  [GUIAREMISION_REMITENTE]: {
    id: GUIAREMISION_REMITENTE,
    nombre: 'GUIA REMISION REMITENTE'
  }
}

const __array = [
  __dictionary[VENTAS_FACTURA],
  __dictionary[VENTAS_BOLETA],
  __dictionary[VENTAS_NOTACREDITO_FACTURA],
  __dictionary[VENTAS_NOTACREDITO_BOLETA],
  __dictionary[VENTAS_NOTADEBITO],
  __dictionary[VENTAS_TICKET],
  __dictionary[GUIAELECTRONICA_TRANSFERENCIAS],
  __dictionary[GUIAREMISION_REMITENTE]
]

const __values = [
  VENTAS_FACTURA,
  VENTAS_BOLETA,
  VENTAS_NOTACREDITO_FACTURA,
  VENTAS_NOTACREDITO_BOLETA,
  VENTAS_NOTADEBITO,
  VENTAS_TICKET,
  GUIAELECTRONICA_TRANSFERENCIAS,
  GUIAREMISION_REMITENTE
]

export default Object.freeze({
  VENTAS_FACTURA,
  VENTAS_BOLETA,
  VENTAS_NOTACREDITO_FACTURA,
  VENTAS_NOTACREDITO_BOLETA,
  VENTAS_NOTADEBITO,
  GUIAELECTRONICA_TRANSFERENCIAS,
  GUIAREMISION_REMITENTE,
  VENTAS_TICKET,
  __dictionary,
  __array,
  __values
})
